export const BOOLEAN_STRING = Object.freeze({
  TRUE: 'true',
  FALSE: 'false',
});

export const ARIA = Object.freeze({
  EXPANDED: 'aria-expanded',
});

export const MAGIC_NUMBERS = Object.freeze({
  /**
   * Time in milliseconds
   */
  THROTTLE_INTERVAL: 300,
  /**
   * Time in milliseconds
   */
  DEBOUNCE_INTERVAL: 300,
  /**
   * Number
   */
  RESIZE_BREAKPOINT: 992,
  /**
   * Number
   */
  MENU_COLLAPSE_SCROLL_POINT: 550,
  MENU_EXPAND_SCROLL_POINT: 520,
  MENU_EXPANDING_SCROLL_POINT: 620,
});
